import { template as template_409fd78459ec4ac990588052c6b60b16 } from "@ember/template-compiler";
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import TextControl from 'eflex/components/bs-form/element/control/text';
export default class NumberControl extends Component {
    onChange = (value)=>{
        if (isPresent(value)) {
            value = Number(value);
        }
        this.args.onChange(value);
    };
    static{
        template_409fd78459ec4ac990588052c6b60b16(`
    <TextControl
      @type='number'
      @id={{@id}}
      @disabled={{@disabled}}
      @readonly={{@readonly}}
      @ariaDescribedBy={{@ariaDescribedBy}}
      @value={{@value}}
      @size={{@size}}
      @units={{@units}}
      @validationType={{@validationType}}
      @onChange={{this.onChange}}
      ...attributes
    />
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
